const usageTypeEnum = {
  MINICOURSE: 0,
  QUIZ: 1,
}
const data = [
  {
    id: usageTypeEnum.MINICOURSE,
    title: 'Mini-course',
    //description: 'You can also make AI add images and questions',
  },
  {
    id: usageTypeEnum.QUIZ,
    title: 'Quiz',
    //description: 'You can set # of questions and difficulty level',
  },
]
export default data
